export default __webpack_public_path__ + "79d9a36a9a4cfd0b1df29624d3106657.jpg";